import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, effect, ChangeDetectorRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../core/services/auth.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { Enums } from '../../shared/models/enums';
import { CommonService } from '../../shared/services/common.service';
import { ModalService } from '../../shared/services/modal.service';
import { ParentChildCommunicationService } from '../../shared/services/parent-child-communication.service';
import { ToastService } from '../../shared/services/toast.service';
import { CommonDataService } from '../services/commonData.service';
import { MeasureDocumentUploadDataService } from '../services/measureDocumentUploadDataService';
import { ShowImagePreviewModalComponent } from '../show-image-preview/show-image-preview-modal.component';
declare var $: any;
@Component({
    selector: '[ifc-more-info-modal]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './more-info-page-modal.component.html',
    styleUrls: ['./more-info-page-modal.component.scss'],
    host: { 'class': 'modal-host-right-panel' },
    providers: [NgbCarouselConfig],
    standalone: true,
    imports: [NgTemplateOutlet, NgClass]
})

export class InfoPageModalComponent implements OnInit {

    heading: string;
    measureText: string;
    meaureDescription: string;
    pageNo: string;
    confirmationStatus = Enums.confirmationStatus;
    action: Subject<any> = new Subject();
    materialDescriptions: Array<string> = [];
    moreInfo: string;
    toolName: string;
    tabName: string;
    isLoggedIn: boolean = false;
    version: any;
    imgPath: string = "./assets/images/";
    imgPathV3: string = "./assets/images/V3/";
    swatchesImagesPath: string = "";  // "./assets/images/SwatchesImages/";
    //swatchesImagesPath: string = "C:/WBG/Export/SwatchesImages/";
    tool: string;
    imgFileName: string; // = "more-info-manual.png";
    measure: string;

    jsonTemplates = [];
    selectedImage: any = null;
    selectedIndex: number = 0;
    private readonly _onLanguageChanged = toSignal(this.parentChildCommunicationService.on('onLanguageChanged'));
    objSwatches: any;
    showVisible: boolean = true;
    measureTypeId: any;
    measureImages: any;
    swatchesImagesJson = [];
    selectedImageIndex: any;
    isApiCompleted: boolean = false;
    constructor(
        public modalRef: MDBModalRef,
        public modalRef1: MDBModalRef,
        private commonDataService: CommonDataService,
        private commonService: CommonService,
        public authService: AuthService,
        public userPersistenceService: UserPersistenceService,
        public parentChildCommunicationService: ParentChildCommunicationService,
        private modalService: ModalService,
        private measureDocumentUploadedDataService: MeasureDocumentUploadDataService,
        private toasterService: ToastService,

        private cdr: ChangeDetectorRef) {
        effect(() => { const p = this._onLanguageChanged(); if (p != null) this.onLanguageChanged(); });
    }

    ngOnInit() {
        this.swatchesImagesPath = window.location.origin + '/swatchesimages/';
        this.imageChangeOnSelectedLanguage();
        if (this.authService.isAuthenticated()) {
            this.isLoggedIn = true;
        }
        console.log('more info data', this.moreInfo);
        this.getMeasureImageDetails();
    }
    hasValidImagePath(): boolean {
        return this.jsonTemplates.some(template => template.imagePath);
    }
    prepareTemplate() {
        console.log('----prepareTemplate-------', this.objSwatches);
        this.jsonTemplates = [];
        for (let i = 0; i < this.objSwatches.images.length; i++) {
            let obj = {
                imageName: this.objSwatches.images[i].name,
                cssClass: '',
                descriptionHtml: this.objSwatches.images[i].description,
                imageSource: this.objSwatches.images[i].imageSource,
                imagePath: this.objSwatches.images[i].imagePath,
                isDescriptiveImg: this.objSwatches.images[i].isDescriptiveImg,
            };
            if (this.objSwatches.images.length >= 4) {
                obj.cssClass = 'col-lg-6 p-2 img-4';
            }

            else if (this.objSwatches.images.length == 3) {
                if (i == 0) {
                    obj.cssClass = 'col-lg-12 p-2 image-large';
                } else if (i > 0) {
                    obj.cssClass = 'col-lg-4 p-2 img-small';
                }
            }

            else if (this.objSwatches.images.length == 2) {
                if (i == 0) {
                    obj.cssClass = 'col-lg-12 p-2 image-large';
                } else if (i > 0) {
                    obj.cssClass = 'col-lg-4 p-2 img-small';
                }
            }

            else if (this.objSwatches.images.length == 1) {
                if (i == 0) {
                    obj.cssClass = 'col-lg-12 p-2 image-large';
                }
            }

            this.jsonTemplates.push(obj);

        }
        this.selectedImage = this.jsonTemplates[0];
    }

    onImageSelect(element, index: number) {
        //this.selectedImage = element;
        this.selectedImageIndex = index;
    }

    onCancelClick() {
        this.modalRef.hide();
        this.action.next('Cancel');
    }

    onLanguageChanged() {
        this.imageChangeOnSelectedLanguage();
    }

    imageChangeOnSelectedLanguage() {

        //switch (this.userPersistenceService.selectedLanguage) {
        //    case Constants.ENGLISH:
                this.imgFileName = "more-info-manual.png";
        //        break;
        //    case Constants.CHINESE:
        //        this.imgFileName = "more-info-manual-chinese.png";
        //        break;
        //    case Constants.SPANISH:
        //        this.imgFileName = "more-info-manual-spanish.png";
        //        break;
        //    case Constants.FRENCH:
        //        this.imgFileName = "more-info-manual-french.png";
        //        break;
        //    default:
        //        this.imgFileName = "more-info-manual.png";
        //        break;
        //}
    }

    onMoreInfo_Click() {
        let pagePdf;
        if (this.version == 3) {


            if (this.tabName === "ENERGY") {
                pagePdf = this.commonDataService.edgeUserGuid_Energy_V3 + this.pageNo;
                window.open(pagePdf, "_blank");
            }
            else if (this.tabName === "WATER") {
                pagePdf = this.commonDataService.edgeUserGuid_Water_V3 + this.pageNo;
                window.open(pagePdf, "_blank");
            }
            else if (this.tabName === "MATERIAL") {
                pagePdf = this.commonDataService.edgeUserGuid_Material_V3 + this.pageNo;
                window.open(pagePdf, "_blank");
            }

        } else {
            pagePdf = this.commonDataService.edgeUserGuidUrl[this.userPersistenceService.selectedLanguage] + this.pageNo;
            window.open(pagePdf, "_blank");
        }


        this.commonService.record_gtag('ProjectPDFDownload' + '/' + this.toolName, this.tabName);
        this.modalRef.hide();
    }

    //private saveDownloadStatictics() {
        
    //        var downloadstatisticsData = { toolName: this.toolName, tabName: this.tabName }
    //        this.commonDataService.saveDownloadStatictics(downloadstatisticsData)
    //            .subscribe((response) => { 
    //                (err: any) => console.error('err at saveDownloadStatictics', err));
       
    //}

    openImagePopup(objSelectedImage: any) {
        console.log('objSelectedImage', objSelectedImage);
        if (objSelectedImage && objSelectedImage.imageName) {
            console.log('this.swatchesImagesPath ', this.swatchesImagesPath)
            console.log('objSelectedImage.imagePath ', objSelectedImage.imagePath)
            console.log('objSelectedImage.imageName ', objSelectedImage.imageName)
            //let temp = this.swatchesImagesPath + objSelectedImage.imagePath;
            //objSelectedImage.imagePath = temp;
        }

        let temAllImages = this.jsonTemplates.filter(x => x.imageName != objSelectedImage.imageName);
        const modalOptions = {
            class: 'full-modal-dialog',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {
                selectedImage: objSelectedImage,
                allImages: temAllImages,
                swatchesImagesPath: this.swatchesImagesPath
            }
        };
        let self = this;
        this.modalRef1 = this.modalService.openModal(ShowImagePreviewModalComponent, modalOptions);
        this.modalRef1.content.action.subscribe((result: any) => {
            if (result.status === this.confirmationStatus.ok) {
                self.modalRef1.hide();
            }
            if (result.status === this.confirmationStatus.cancel) {
                self.modalRef1.hide();
            }
        
            this.cdr.markForCheck();});
    }

    entervalue: any;
    changeTest() {
        this.objSwatches = this.swatchesImagesJson[this.entervalue];
        this.prepareTemplate();
    }

    call() {
        console.log('call ........')
        this.showVisible = true;
    }

    onImageClick(element, idx) {
        console.log('call11111 ........');
        this.showVisible = false;
        this.selectedImage = element;
        this.selectedIndex = idx;
        if (this.jsonTemplates.length != 4) {
            let tempFirstElement = this.objSwatches.images[0];
            let tempSelectedElement = { name: element.imageName, description: element.descriptionHtml, imageSource: element.imageSource, imagePath: element.imagePath };
            this.objSwatches.images[0] = tempSelectedElement;
            this.objSwatches.images[idx] = tempFirstElement;
            this.prepareTemplate();
        }
    }

    onImgError(event) {
        event.target.src = './assets/images/no-project-image.png';
        //Do other stuff with the event.target
    } 

    getMeasureImageDetails() {
        //this.measureTypeId = "E1091E9D-90C5-4292-B351-002C766BA3C6";
        this.objSwatches = {
            id: '',
            name: '',
            images: []
        },
            this.measureDocumentUploadedDataService.getMeasureImageDetailsById(this.tool, this.measure).subscribe((data) => {
                this.isApiCompleted = true;
                if (data && data.value && data.value.length > 0) {
                    for (let i = 0; i < data.value.length; i++) {
                        let obj = {
                            name: data.value[i].measureImageName,
                            description: data.value[i].description,
                            imageSource: data.value[i].measureImageSource,
                            imagePath: data.value[i].measureImagePath,
                            isDescriptiveImg: data.value[i].isDescriptiveImg
                        }

                        this.objSwatches.images.push(obj);
                        console.log(this.objSwatches);
                    }
                }
                this.prepareTemplate();
            
                this.cdr.markForCheck();},
                error => {
                    this.isApiCompleted = true;
                    this.toasterService.error(this.userPersistenceService.generalTranslation.ErrorMsg);
                
                    this.cdr.markForCheck();});
    }
};